<template>
  <div>
    <table width="100%" height="255px" align="center" cellspacing="0" class="tabs-table">
      <tbody v-for="(item, i) in holdList" :key="'info-'+i">
        <tr v-if="i<10" class="tradd">
          <td class="table-left" colspan="2" style="border-right: none;border-bottom: 1px solid #ccc;font-size: 16px;">控股股东信息</td>
          <td v-if="i === 0" class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="addTabel(item, i)">新增</el-button>
          </td>
          <td v-else class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="deletInfo(item, i)">删除</el-button>
          </td>
        </tr>
        <tr v-if="i<10">
          <td class="table-left left">控股股东姓名</td>
          <td class="table-right">
            <el-input v-model="item.shareName" size="mini" style="width: 200px;" />
          </td>
          <td class="table-left left">证件类型</td>
          <td class="table-right">
            <el-select v-model="item.shareCredType" placeholder="请选择" size="mini">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </td>
        </tr>
        <tr v-if="i<10">
          <td class="table-left left">证件号码</td>
          <td class="table-right">
            <el-input v-model="item.shareCredNo" :disabled="item.disabled" size="mini" style="width: 200px;" />
          </td>
          <td class="table-left left">证件有效期</td>
          <td class="table-right">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="item.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
              至
              <el-date-picker
                v-model="item.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '00'">
          <td class="table-left left">身份证件</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateOne(item, i)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '01'">
          <td class="table-left left">护照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '02'">
          <td class="table-left left">营业执照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '03'">
          <td class="table-left left">其他</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
      </tbody>
      <tbody v-for="(item,index) in actualList" :key="'info1-'+index">
        <tr>
          <td class="table-left" colspan="2" style="border-right: none;border-bottom: 1px solid #ccc;font-size: 16px;">实际控人姓名</td>
          <td v-if="index === 0" class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="addTabelactualList(item, index)">新增</el-button>
          </td>
          <td v-else class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="actuadeletInfo(item, index)">删除</el-button>
          </td>
        </tr>
        <tr>
          <td class="table-left left">实际控人姓名</td>
          <td class="table-right"><el-input v-model="item.shareName" size="mini" style="width: 200px;" /></td>
          <td class="table-left left">证件类型</td>
          <td class="table-right">
            <el-select v-model="item.shareCredType" placeholder="请选择" size="mini">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="table-left left">证件号码</td>
          <td class="table-right"><el-input v-model="item.shareCredNo" :disabled="item.disabled" size="mini" style="width: 200px;" /></td>
          <td class="table-left left">证件有效期</td>
          <td class="table-right">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="item.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
              至
              <el-date-picker
                v-model="item.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '00'">
          <td class="table-left left">身份证件</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateOne(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '01'">
          <td class="table-left left">护照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '02'">
          <td class="table-left left">营业执照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '03'">
          <td class="table-left left">其他</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
      </tbody>
      <tbody v-for="(item, index) in grantList" :key="'info2-'+index">
        <tr>
          <td class="table-left" colspan="2" style="border-right: none;border-bottom: 1px solid #ccc;font-size: 16px;">授权办理人姓名</td>
          <td v-if="index === 0" class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="addTabelgrantList(item, index)">新增</el-button>
          </td>
          <td v-else class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="deletInfogrant(item, index)">删除</el-button>
          </td>
        </tr>
        <tr>
          <td class="table-left left">授权办理人姓名</td>
          <td class="table-right">
            <el-input v-model="item.shareName" size="mini" style="width: 200px;" />
          </td>
          <td class="table-left left">证件类型</td>
          <td class="table-right">
            <el-select v-model="item.shareCredType" placeholder="请选择" size="mini">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="table-left left">证件号码</td>
          <td class="table-right"><el-input v-model="item.shareCredNo" :disabled="item.disabled" size="mini" style="width: 200px;" /></td>
          <td class="table-left left">证件有效期</td>
          <td class="table-right">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="item.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
              至
              <el-date-picker
                v-model="item.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '00'">
          <td class="table-left left">身份证件</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateOne(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '01'">
          <td class="table-left left">护照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '02'">
          <td class="table-left left">营业执照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '03'">
          <td class="table-left left">其他</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
      </tbody>
      <tbody v-for="(item,index) in beneficiaryList" :key="'info3-'+index">
        <tr>
          <td class="table-left" colspan="2" style="border-right: none;border-bottom: 1px solid #ccc;font-size: 16px;">受益所有人信息</td>
          <td v-if="index === 0" class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="addTabelbeneficiaryList(item,index)">新增</el-button>
          </td>
          <td v-else class="table-left" colspan="2" style="text-align: right;padding-right: 20px;border-bottom: 1px solid #ccc;">
            <el-button class="add" size="mini" @click="benefidetelt(item, index)">删除</el-button>
          </td>
        </tr>
        <tr>
          <td class="table-left left">受益所有人姓名</td>
          <td class="table-right"><el-input v-model="item.shareName" size="mini" style="width: 200px;" /></td>
          <td class="table-left left">证件类型</td>
          <td class="table-right">
            <el-select v-model="item.shareCredType" placeholder="请选择" size="mini">
              <el-option
                v-for="item in shareCredTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="table-left left">证件号码</td>
          <td class="table-right"><el-input v-model="item.shareCredNo" :disabled="item.disabled" size="mini" style="width: 200px;" /></td>
          <td class="table-left left">证件有效期</td>
          <td class="table-right">
            <div style="display: flex;align-items: center;width: 320px">
              <el-date-picker
                v-model="item.shareCredValidStart"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
              至
              <el-date-picker
                v-model="item.shareCredValidEnd"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '00'">
          <td class="table-left left">身份证件</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateOne(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '01'">
          <td class="table-left left">护照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '02'">
          <td class="table-left left">营业执照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr v-if="item.shareCredType == '03'">
          <td class="table-left left">证件照</td>
          <td class="table-right" colspan="3">
            <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
            <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
            <el-button type="text" class="fontStyle" @click="dialogUpdateThree(item)">更新</el-button>
          </td>
        </tr>
        <tr class="addeas">
          <td class="table-left left">地址（请精确到门牌号）</td>
          <td class="table-right" colspan="3">
            <el-form>
              <el-form-item style="display: flex;">
                <el-row>
                  <div v-if="index === 0" style="display: flex;">
                    <el-form-item prop="shareProvinceName">
                      <el-select v-model="item.shareProvinceName" placeholder="省" :clearable="true" style="width:110px;" size="mini" @change="getCityData">
                        <el-option
                          v-for="(int) in provinceArray"
                          :key="int.id"
                          :label="int.name"
                          :value="int.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="shareCityName">
                      <el-select v-model="item.shareCityName" placeholder="市" :clearable="true" style="padding-left:5px;width:110px;" size="mini" @change="getCountyData">
                        <el-option
                          v-for="(int) in cityArray"
                          :key="int.id"
                          :label="int.name"
                          :value="int.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="shareAreaName">
                      <el-select v-model="item.shareAreaName" placeholder="区/县" :clearable="true" style="padding-left:5px;width:110px;" size="mini" @change="changeCountyData">
                        <el-option
                          v-for="(int) in countyArray"
                          :key="int.id"
                          :label="int.name"
                          :value="int.id"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item prop="shareStreet">
                      <el-input v-model="item.shareStreet" style="width:340px" placeholder="请输入详细地址(精确到门牌号)" size="mini" />
                    </el-form-item>
                  </div>
                </el-row>
              </el-form-item>
            </el-form>
          </td>
        </tr>
      </tbody>
    </table>
    <el-button class="submit add" @click="InfoUpdate">提交</el-button>
    <!-- 证件照 -->
    <el-dialog
      title="上传证件"
      :visible.sync="dialogVisibleinfo"
      width="30%"
    >
      <el-form
        ref="personalInfoForm"
        :model="personalInfoForm"
        label-width="140px"
        size="small"
      >
        <el-form-item label="身份证正面：">
          <el-upload
            ref="idCardForm"
            style="display:inline-block;margin-right:15px;"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :limit="1"
            :class="{hide:personZ.hide}"
            list-type="picture-card"
            :on-change="(file, fileList) => {handleChangeByPersonal(file, fileList2,personZ)}"
            :on-remove="(file, fileList) => {frontHandleRemoveByPersonal(file, fileList2,personZ)}"
            :http-request="(file, fileList) => {frontHandleUploadByPersonal(file, fileList2,personZ)}"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
        <el-form-item label="身份证反面：">
          <el-upload
            ref="idCardFormlist"
            class="upload-demo"
            style="display:inline-block;margin-right:15px;"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :limit="1"
            :class="{hide:personZ.hide}"
            list-type="picture-card"
            :on-change="(file, fileList) => {handleChangeByPersonal(file, fileList2,personZ)}"
            :on-remove="(file, fileList) => {backHandleRemoveByPersonal(file, fileList2,personZ)}"
            :http-request="(file, fileList) => {backHandleUploadByPersonal(file, fileList2,personZ)}"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="suBmitPersonal(1)">提交</el-button>
      </span>
    </el-dialog>
    <!-- 营业执照 -->
    <el-dialog
      :title="title"
      :visible.sync="licenseUpload"
      width="30%"
      center
    >
      <div class="business">
        <span>{{ title }}：</span>
        <el-upload
          ref="uploadPersonal"
          style="display:inline-block;margin-right:15px;"
          action=""
          accept="image/jpeg,image/jpg,image/png"
          :limit="1"
          list-type="picture-card"
          :on-remove="(file) => {licenseHandleRemove(file)}"
          :http-request="(file) => {licenseHandleUpload(file)}"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upload">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyInfo, shareInfoSearch, shareInfoUpdate, customerUpdate } from '@/api/info'
import { setNull, getArea } from '@/api/common/common'
import store from '@/store'
import Session from '@/utils/session'
import File from '@/utils/file'
import compress from '@/utils/compress'
import imgSize from '@/utils/imgSize'
import { SelectCertificateOnClick, SignOnClick } from '@/utils/CryptoKit'

export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisibleimage: false,
      dialogVisibleinfo: false,
      dialogVisibleinfolist: false,
      licenseUpload: false,
      dialogVisibThree: false,
      dialogVisibCardUrl: false,
      jsonObj: [],
      fileList2: [],
      sourceData: {},
      title: null,
      info: [
        {
          name: '基本信息',
          id: 1
        },
        {
          name: '其他信息',
          id: 2
        }
      ],
      shareCredTypelist: [
        { value: '00', label: '身份证' },
        { value: '01', label: '护照' },
        { value: '02', label: '营业执照' },
        { value: '03', label: '其他' }
      ],
      // 省
      provinceArray: [],
      cityArray: [],
      countyArray: [],
      personalInfoForm: {
        customerId: store.getters.customerId,
        corporationIdCardUrlFront: null,
        corporationIdCardUrlBack: null,
        editFlag: 1,
        isOverDue: true,
        // 身份证
        idCard: null,
        // 身份证
        idCardUrlFront: null,
        // 身份证
        idCardUrlBack: null,
        // 绑定手机
        phoneMask: Session.getItem('phoneMask'),
        // 所在省
        personProv: null,
        // 所在省编号
        personProvNo: null,
        // 所在市
        personCity: null,
        // 所在市编号
        personCityNo: null,
        // 所在县区
        personCounties: null,
        // 所在县区编号
        personCountiesNo: null,
        // 地址
        address: null,
        // 是否跨境 0-非跨境 1-跨境
        crossBorderFlag: '0',
        // 币种
        ccy: 'CNY',
        // 证件类型1：身份证；2：其他
        corporationIdCardType: '1',
        // 操作人-手机号
        openUserId: Session.getItem('phone')
      },
      num: 0,
      imageUrl: '',
      gengxinlist: false,
      personZ: {
        hide: false,
        flagUrl: 'personFrontUrl'
      },
      actualList: [],
      beneficiaryList: [],
      grantList: [],
      holdList: [],
      createStart: [],
      createStartTime: [],
      grantStartTime: [],
      actuaStartTime: [],
      infoForm: {
        // 18684359154364416
        customerId: store.getters.customerId,
        certPicUrl: null,
        certBackPicUrl: null,
        tradeLicenseUrl: null,
        shareName: null,
        shareCredType: null,
        shareCredNo: null,
        shareCredValidStart: null,
        shareCredValidEnd: null,
        editFlag: 1,
        isOverDue: true,
        // 企业名称
        companyName: null,
        // 客户编号
        customerCode: null,
        // 统一信用代码
        tradeLicenseNo: null,
        // 所在省
        tradeLicenseProvince: null,
        // 所在市
        tradeLicenseCity: null,
        // 所在县区
        tradeLicenseCountie: null,
        // 详细地址
        address: null,
        // 成立日期
        openDate: null,
        // 入网时间
        createTime: null,
        // 经营时限开始
        businessTermFrom: null,
        // 经营时限结束
        businessTermTo: null,
        // 经营期限至-长期标志 1：长期；0：非长期
        businessTermValid: null,
        // 法人姓名
        corporationName: null,
        // 法人身份证
        corporationIdCardNo: null,
        // 法人身份证mask
        corporationIdCardNoMask: null,
        // 联系人姓名
        contactName: null,
        // 联系人手机号
        contactPhone: null,
        // 联系人手机号mask
        contactPhoneMask: null,
        // 营业执照img
        licenseImg: null,
        // 身份证正面img
        idCardFrontImg: null,
        // 身份证反面img
        idCardBackImg: null,
        // 收货地址
        defaultAddress: null,
        // 客户机构号
        orgNo: null,
        // 实名认证标志 （00-临时,01-弱实名,02-强实名）
        authFlag: null,
        auditStatus: null,
        // 省 市 区 编码
        tradeLicenseProvinceNo: null,
        tradeLicenseCityNo: null,
        tradeLicenseCountieNo: null
      },
      item: {},
      arr: ''
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'enterpriseInfo') {
        this.getData()
      }
    }
  },
  created() {
    this.getData()
    this.getArea()
    this.InfoSearch()
  },
  methods: {
    // 身份证更新
    dialogUpdateOne(item) {
      this.$message.error('请通过dopay或小金管控APP进行更新资料！')
      // this.dialogVisibleinfo = true
      // this.item = item
    },
    // 营业执照更新
    dialogUpdateThree(item) {
      this.$message.error('请通过dopay或小金管控APP进行更新资料！')
      // console.log('shareCredType', item.shareCredType)
      // this.infoForm.shareCredType = item.shareCredType
      // if (item.shareCredType === '01') {
      //   this.title = '上传证件照片'
      // } else if (item.shareCredType === '03') {
      //   this.title = '上传证件照片'
      // } else if (item.shareCredType === '02') {
      //   this.title = '上传营业执照'
      // }
      // this.licenseUpload = true
      // this.item = item
    },
    // 上传身份证正面图片
    frontHandleUploadByPersonal(data, fileList, item) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.personalInfoForm.corporationIdCardUrlFront = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     this.personalInfoForm.corporationIdCardUrlFront = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 上传身份证反面图片
    backHandleUploadByPersonal(data, fileList, item) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.personalInfoForm.corporationIdCardUrlBack = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     this.personalInfoForm.corporationIdCardUrlBack = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 提交证件
    suBmitPersonal() {
      const param = setNull(this.personalInfoForm)
      customerUpdate(param).then(res => {
        this.$message.success(res.message)
        this.dialogVisibleinfo = false
      }).catch(error => {
        this.$message.error(error)
        this.dialogVisibleinfo = false
      })
      this.holdList.forEach(int => {
        if (int.id === this.item.id) {
          this.item.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.item.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
        }
      })
      this.actualList.forEach(int => {
        if (int.id === this.item.id) {
          this.item.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.item.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
        }
      })
      this.grantList.forEach(int => {
        if (int.id === this.item.id) {
          this.item.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.item.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
        }
      })
      this.beneficiaryList.forEach(int => {
        if (int.id === this.item.id) {
          this.item.certPicUrl = this.personalInfoForm.corporationIdCardUrlFront
          this.item.certBackPicUrl = this.personalInfoForm.corporationIdCardUrlBack
          this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
        }
      })
      this.$refs['idCardForm'].clearFiles()
      this.$refs['idCardFormlist'].clearFiles()
    },
    // 图片删除事件
    licenseHandleRemove(file) {
      this.infoForm.tradeLicenseUrl = null
    },
    // 上传营业执照
    licenseHandleUpload(data) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.infoForm.tradeLicenseUrl = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     this.infoForm.tradeLicenseUrl = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 上传
    upload() {
      const param = {
        editFlag: 1,
        customerId: store.getters.customerId,
        isOverDue: true,
        tradeLicenseUrl: this.infoForm.tradeLicenseUrl
      }
      customerUpdate(param).then(res => {
        this.$message.success(res.message)
        this.holdList.forEach(int => {
          if (int.id === this.item.id) {
            this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
          }
        })
        this.actualList.forEach(int => {
          if (int.id === this.item.id) {
            this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
          }
        })
        this.grantList.forEach(int => {
          if (int.id === this.item.id) {
            this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
          }
        })
        this.beneficiaryList.forEach(int => {
          if (int.id === this.item.id) {
            this.item.tradeLicenseUrl = this.infoForm.tradeLicenseUrl
          }
        })
        this.$refs['uploadPersonal'].clearFiles()
        this.licenseUpload = false
      }).catch(error => {
        this.$message.error(error)
        this.$refs['uploadPersonal'].clearFiles()
        this.licenseUpload = false
      })
    },
    addTabel(item, i) {
      const summaryArr = {
        identityType: '00',
        shareName: item.shareName,
        shareCredType: item.shareCredType,
        shareCredNo: item.shareCredNo,
        shareCredValidStart: item.shareCredValidStart,
        certPicUrl: null,
        certBackPicUrl: null,
        tradeLicenseUrl: null,
        shareCredValidEnd: item.shareCredValidEnd
      }
      this.holdList.push(summaryArr)
    },
    addTabelactualList(item, int) {
      const summaryArr = {
        identityType: '01',
        shareName: item.shareName,
        shareCredType: item.shareCredType,
        shareCredNo: item.shareCredNo,
        shareCredValidStart: item.shareCredValidStart,
        certPicUrl: null,
        certBackPicUrl: null,
        tradeLicenseUrl: null,
        shareCredValidEnd: item.shareCredValidEnd
      }
      this.actualList.push(summaryArr)
    },
    addTabelgrantList(item, intlist) {
      const summaryArr = {
        identityType: '02',
        shareName: item.shareName,
        shareCredType: item.shareCredType,
        shareCredNo: item.shareCredNo,
        shareCredValidStart: item.shareCredValidStart,
        certPicUrl: null,
        certBackPicUrl: null,
        tradeLicenseUrl: null,
        shareCredValidEnd: item.shareCredValidEnd
      }
      this.grantList.push(summaryArr)
    },
    addTabelbeneficiaryList(item, intl) {
      const summaryArr = {
        identityType: '03',
        shareName: item.shareName,
        shareCredType: item.shareCredType,
        shareCredNo: item.shareCredNo,
        shareCredValidStart: item.shareCredValidStart,
        shareCredValidEnd: item.shareCredValidEnd,
        shareProvinceId: item.shareProvinceId,
        shareProvinceName: item.shareProvinceName,
        shareCityId: item.shareCityId,
        shareCityName: item.shareCityName,
        certPicUrl: null,
        certBackPicUrl: null,
        tradeLicenseUrl: null,
        shareAreaId: item.shareAreaId,
        shareAreaName: item.shareAreaName,
        shareStreet: item.shareStreet
      }
      this.beneficiaryList.push(summaryArr)
    },
    // 企业客户其他信息查询
    InfoSearch: function() {
      this.arr = ''
      const param = {
        customerId: this.infoForm.customerId
      }
      shareInfoSearch(param).then((res, index) => {
        for (const key in res.data.actualList) {
          res.data.actualList[key].disabled = true
        }
        this.actualList = res.data.actualList
        for (const key in res.data.beneficiaryList) {
          res.data.beneficiaryList[key].disabled = true
        }
        this.beneficiaryList = res.data.beneficiaryList
        for (const key in res.data.grantList) {
          res.data.grantList[key].disabled = true
        }
        this.grantList = res.data.grantList
        for (const key in res.data.holdList) {
          res.data.holdList[key].disabled = true
        }
        this.holdList = res.data.holdList
      }).catch(error => {
        console.log(error) // 捕获异常
      })
    },
    // 企业客户其他信息保存修改beneficiaryList
    InfoUpdate: function() {
      for (const item of this.beneficiaryList) {
        if (!this.infoForm.tradeLicenseProvinceNo || !this.infoForm.tradeLicenseCityNo || !this.infoForm.tradeLicenseCountieNo || !item.shareStreet) {
          this.$message.error('请完善地址信息')
          return
        }
        item.identityType = '03'
        item.shareProvinceId = this.infoForm.tradeLicenseProvinceNo
        item.shareProvinceName = this.infoForm.tradeLicenseProvince
        item.shareCityId = this.infoForm.tradeLicenseCityNo
        item.shareCityName = this.infoForm.tradeLicenseCity
        item.shareAreaId = this.infoForm.tradeLicenseCountieNo
        item.shareAreaName = this.infoForm.tradeLicenseCountie
      }

      const param = {
        customerId: this.infoForm.customerId,
        // OCR是否识别是否编辑 0：未编辑；1：已编辑
        deleteIds: this.arr.substring(0, this.arr.length - 1),
        isEdit: 0,
        companyFxqShareInfoUpdateListReqList: JSON.parse(JSON.stringify(this.actualList.concat(this.beneficiaryList).concat(this.holdList).concat(this.grantList)))
      }
      const signKeys = ['shareName', 'shareCredNo']
      param.isCfcaDecrypt = SelectCertificateOnClick()
      for (const item of signKeys) {
        for (let i = 0; i < param.companyFxqShareInfoUpdateListReqList.length; i++) {
          if (param.companyFxqShareInfoUpdateListReqList[i][item]) {
            param.companyFxqShareInfoUpdateListReqList[i][item] = SignOnClick(param.companyFxqShareInfoUpdateListReqList[i][item]).result
          }
        }
      }
      shareInfoUpdate(param).then(res => {
        this.$message.success(res.message)
        this.personalInfoForm.corporationIdCardUrlFront = ''
        this.personalInfoForm.corporationIdCardUrlBack = ''
        this.infoForm.tradeLicenseUrl = ''
      })
    },
    // 删除
    deletInfo(item, index) {
      this.arr = this.arr + item.id + ','
      this.holdList.splice(index, 1)
    },
    actuadeletInfo(item, index) {
      this.arr = this.arr + item.id + ','
      this.actualList.splice(index, 1)
    },
    deletInfogrant(item, index) {
      this.arr = this.arr + item.id + ','
      this.grantList.splice(index, 1)
    },
    benefidetelt(item, index) {
      this.arr = this.arr + item.id + ','
      this.beneficiaryList.splice(index, 1)
    },
    // 点击切换
    tabChange(index) {
      this.num = index
    },
    //, 获取省
    getArea() {
      const param = {}
      getArea(param)
        .then(res => {
          this.provinceArray = res.data.children
        })
        .catch(error => {
          // 捕获异常
          console.log(error)
        })
    },
    // 注册地址市
    getCityData(val) {
      this.cityArray = []
      this.countyArray = []
      this.infoForm.tradeLicenseCity = null
      this.infoForm.tradeLicenseCityNo = null
      this.infoForm.tradeLicenseCountie = null
      this.infoForm.tradeLicenseCountieNo = null
      this.infoForm.tradeLicenseProvinceNo = val
      for (const item of this.provinceArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseProvince = item.name
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.cityArray = res.data.children
              resolve(this.cityArray)
            })
            .catch(error => {
              reject(error)
              console.log(error) // 捕获异常
            })
        })
      }
    },
    // 注册县
    getCountyData(val) {
      this.countyArray = []
      this.infoForm.tradeLicenseCountie = null
      this.infoForm.tradeLicenseCountieNo = null
      this.infoForm.tradeLicenseCityNo = val
      for (const item of this.cityArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseCity = item.name
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.countyArray = res.data.children
              resolve(this.countyArray)
            })
            .catch(error => {
              console.log(error) // 捕获异常
              reject(error)
            })
        })
      }
    },
    // 注册区事件
    changeCountyData(val) {
      this.infoForm.tradeLicenseCountieNo = val
      for (const item of this.countyArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseCountie = item.name
        }
      }
    },
    gengxin() {
      this.gengxinlist = true
    },
    // 图片删除事件
    frontHandleRemoveByPersonal(file, fileList, item) {
      // this.personalInfoForm.idCardFront = null
      this.personalInfoForm.corporationIdCardUrlFront = null
    },
    // 图片删除事件
    backHandleRemoveByPersonal(file, fileList, item) {
      // this.personalInfoForm.idCardBack = null
      this.personalInfoForm.corporationIdCardUrlBack = null
    },
    // 图片上传change事件
    handleChangeByPersonal(file, fileList, item) {
      console.log(fileList)
      console.log(fileList.length)
      if (fileList.length >= 1) {
        item.hide = true
      }
      console.log(item.hide)
    },
    // 查询
    getData() {
      const param = {
        customerId: this.infoForm.customerId
      }
      getCompanyInfo(param)
        .then(res => {
          console.log(res, '查询企业客户信息individual')
          this.infoForm = Object.assign({}, res.data)
          // 营业执照img
          if (res.data.tradeLicense) {
            this.infoForm.licenseImg = res.data.tradeLicense.url
          } else {
            this.infoForm.licenseImg = ''
          }
          // 身份证正面img
          if (res.data.idCardFront) {
            this.infoForm.idCardFrontImg = res.data.idCardFront.url
          } else {
            this.infoForm.idCardFrontImg = ''
          }
          // 身份证反面img
          if (res.data.idCardBack) {
            this.infoForm.idCardBackImg = res.data.idCardBack.url
          } else {
            this.infoForm.idCardBackImg = ''
          }
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 实名认证
    personalAuth() {
      this.$router.push({
        name: 'companyAuth'
      })
    },
    // 管理收货地址
    address() {
      this.$router.push({
        name: 'manageAddress',
        params: {
          orgId: this.infoForm.orgNo
        }
      })
    },
    // 修改手机号
    editPhone() {
      this.$router.push({
        name: 'editPhone'
      })
    }
  }
}
</script>

<style scoped>
.inner {
  padding: 35px;
}
.tabs-table {
  padding: 0;
  border: solid #ccc;
  border-width: 1px 0px 0px 1px;
}
.tabs-table tr {
  height: 40px;
}
.table-left {
  background: #f4f4f6;
  padding-left: 23px;
  font-size: 12px;
  color: #5e5e5e;
  width: 138px;
  border-right: solid #d8d8d8;
  border-width: 0px 1px 1px 0px;
}
.table-right {
  color: #333;
  font-size: 12px;
  padding-left: 23px;
  border: solid #d8d8d8;
  border-width: 0px 1px 1px 0px;
}
.fontStyle {
  width: 42px;
  height: 19px;
  margin-left: 12px;
  font-size: 14px;
  color: #DE201D;
  line-height: 19px;
}
.fontStyle a{
  color: #498AEA;
  text-decoration:underline;
}
.add{
  background-color: #258FFA;color: #fff;border: 1px solid #258FFA;
}
.addred{
  background-color: #DE201D;color: #fff;border: 1px solid #DE201D;
}
.submit{
  margin: 20px auto;
  display: flex;
}
.visible{
  margin-left: 50px;
}
.active{
  background-color: #498AEA;
  color: #fff;
  border: 1px solid #498AEA;
}
.left{
  border-bottom: 1px solid #ccc;
}
.addeas .el-form-item{
  margin-bottom: 0px;
}
</style>
